<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Message Create</li>
      </ol>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../router/router'
export default {
  components: {

  },
  data() {
    return {

    }
  },
  serverPrefetch() {
  },
  created() {

  },
  mounted() {
  },
  methods: {

  }
}
</script>
